<template>
  <div class="cp-outer" :class="{'dialog-only' : dialogOnly}">
    <router-view></router-view>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import JobOfferStore from '../../store/modules/joboffer';
import utils from '../../lib/utils'

const { mapActions } = createNamespacedHelpers('joboffer');

// Mock server data
if (typeof window.Jobpassion === 'undefined') {
  window.Jobpassion = {};
}

export default {
  name: 'JobOfferLanding',
  watch: {
    $route(to, _from) {
      console.log(to);
      console.log(to.fullPath.indexOf('appointment') !== -1
        || to.fullPath.indexOf('thankyou') !== -1);
      this.dialogOnly = to.fullPath.indexOf('appointment') !== -1
        || to.fullPath.indexOf('thankyou') !== -1;
    }
  },

  data() {
    return {
      dialogOnly: false
    };
  },

  created() {
    if (utils.hasProperty(window, 'careerpeakr') && utils.hasProperty(window.careerpeakr, 'jobOfferId')) {
      this.loadJobOffer({ jobOfferId: window.careerpeakr.jobOfferId, locale: this.$careerpeakr.locale });
    } else {
      this.loadJobOffer({ jobOfferId: this.$route.params.id, locale: this.$careerpeakr.locale });
    }
  },

  methods: {
    ...mapActions({
      loadJobOffer: JobOfferStore.types.ACTIONS.LOAD_JOBOFFER
    })
  }
};
</script>

<style lang="scss" scoped>

.cp-outer {
  &.dialog-only {
    background: transparent url(/assets/img/CP_Header_Arbeitnehmer_01.jpg) no-repeat top right;
    background-size: cover;
    padding-top: 80px;
    padding-bottom: 60px;
  }
}

.modal-opened {
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

</style>
